import ScheduleSection from './ScheduleSection';

const IntroSection = ({ id, description }) => {
	
	return (
		<div className="space-y-8">
			<div>
				<h3 className="text-2xl font-bold text-gray-900 mb-4">수업 소개</h3>
				<p className="text-lg text-gray-700 leading-relaxed">{description}</p>
			</div>
			<div>
				<h3 className="text-2xl font-bold text-gray-900 mb-4">스케줄</h3>
				<ScheduleSection classId={id}/>
			</div>
		</div>
	);
};

export default IntroSection;